(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["linko-search-suggest"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.linkoSmartSearch) return;
  window.linkoSmartSearch = true;

  var SYNONYMS = {
    '鎖': '智能門鎖',
    '門鎖': '智能門鎖',
    '電子鎖': '智能門鎖',
    '智能鎖': '智能門鎖',
    'lock': '智能門鎖',
    'locks': '智能門鎖',
    'door lock': '智能門鎖',
    'doorlock': '智能門鎖',
    'smart lock': '智能門鎖',
    '燈掣': '燈掣插座',
    '開關': '智能開關',
    '插蘇': '插座',
    '插座': '燈掣插座',
    'switch': '燈掣插座',
    'socket': '燈掣插座',
    'sockets': '燈掣插座',
    '叉電': 'Schneider Charge',
    '叉電車': 'Schneider Charge',
    '充電樁': 'Schneider Charge',
    '充電站': 'Schneider Charge',
    'ev': 'Schneider Charge',
    'evc': 'Schneider Charge',
    'charger': 'Schneider Charge',
    'ev charger': 'Schneider Charge',
    'homekit': 'HomeKit',
    'home kit': 'HomeKit',
    '蘋果': 'HomeKit',
    'apple home': 'HomeKit',
    '網關': '網關',
    'hub': '網關',
    'gateway': '網關',
    'aqara': 'Aqara',
    '綠米': 'Aqara',
    'lockly': 'Lockly',
    'philips': 'Philips 門鎖',
    '飛利浦': 'Philips 門鎖',
    '鹿客': '鹿客',
    'lockin': '鹿客',
    '軌道燈': '磁吸軌道燈',
    '路軌燈': '磁吸軌道燈',
    '磁吸': '磁吸軌道燈',
    'p20': 'Yeelight Pro P20'
  };

  window.linkoRewriteQuery = function (query) {
    if (!query) return query;
    var key = String(query).trim().toLowerCase();
    return SYNONYMS[key] || query;
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var input = form.querySelector('input[name="q"][type="search"], input[name="q"][type="text"]');
    if (!input || !form.getAttribute('action')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1 && action.indexOf('search') === -1) return;
    var rewritten = window.linkoRewriteQuery(input.value);
    if (rewritten && rewritten !== input.value) input.value = rewritten;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
